module.exports = __webpack_public_path__ + "img/53-image-1-1@2x.3bf2876e.png";